import { FormCheckbox } from "@jsq/ds/forms";

interface Props {
  readonly: boolean;
}

const CertifiedFieldFormValue = ({ readonly }: Props) => {
  return (
    <FormCheckbox
      name="isCertifiedDocument"
      label={"This is a certified document"}
      disabled={readonly}
    />
  );
};

export default CertifiedFieldFormValue;
